import { SingleSpan } from './CustomComponents';
import { SingleInputSection } from './SingleInputSection';

import { InputTextSelect } from 'components/UIComponents/InputTextSelect';

import './SingleInputTextSelectWithLabel.css';

type Props = {
  className?: string;
  label: string;
  readonly?: boolean;
  value?: string | null;
  onChange?: (value: string) => void;
};

export const SingleInputTextSelectWithLabel = ({
  className,
  label,
  readonly,
  value,
  onChange,
}: Props) => {
  return (
    <SingleInputSection label={label} className={className}>
      {readonly ? (
        <SingleSpan>{value}</SingleSpan>
      ) : (
        <InputTextSelect
          className="single-input-text-select"
          value={value ?? ''}
          onChange={onChange}
          placeholder=""
        />
      )}
    </SingleInputSection>
  );
};
